module.exports = __webpack_public_path__ + "static/media/clock-ic.2b79f4d0.png";